import script from "./ArticleOutline.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleOutline.vue?vue&type=script&setup=true&lang=js"

import "./ArticleOutline.vue?vue&type=style&index=0&id=dbaf057a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbaf057a"]])

export default __exports__